// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3CAAHVX_UQofc8 {\n  background-color: transparent;\n  height: 32px;\n  line-height: 32px;\n  margin-right: 4px;\n  padding-right: 10px;\n  white-space: nowrap;\n}\n.theme-light ._3CAAHVX_UQofc8 {\n  color: #FFFFFF;\n}\n.theme-light ._3CAAHVX_UQofc8:hover {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.body-board-view ._3CAAHVX_UQofc8 {\n  color: var(--dynamic-text-color);\n}\n.theme-light .body-board-view ._3CAAHVX_UQofc8:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n._24G4lMEH6x0za3 {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.theme-light .body-board-view ._24G4lMEH6x0za3 {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.cSOqrUxBxAu8by {\n  margin-right: 2px;\n}\n._33A3ABuhpoZVqw {\n  min-width: 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "_3CAAHVX_UQofc8",
	"buttonOpen": "_24G4lMEH6x0za3",
	"buttonText": "cSOqrUxBxAu8by",
	"buttonIcon": "_33A3ABuhpoZVqw"
};
export default ___CSS_LOADER_EXPORT___;
